import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "../../../Api.js"
import CircularProgress from "@mui/material/CircularProgress"
import { showToast } from "../../../Components/PopupMessage.jsx";
import Navber from "../../../Components/Navber.jsx";

import "./FlightCheckout.css";
import { NoScrollModule } from "yet-another-react-lightbox";

const formatTime = date =>
    new Date(date).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });

const formatDate = date =>
    new Date(date).toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric"
    });


export default function JayrajCheckout() {
    const location = useLocation();
    const results = location?.state?.carddata
    const TraceId = location?.state?.traceId
    const ResultIdx = location?.state?.resultIndex
    console.log("the checkout page is : ", results);
    console.log("the TraceId is : ", TraceId);
    console.log("the ResultIdx is : ", ResultIdx);
    const [fareRule, setFareRule] = useState();
    const [fareQuote, setFareQuote] = useState();

    const segments = results?.Segments?.[0] || []; // array of segments
    const firstSegment = segments[0];
    const stopies = results?.Segments?.[0]

    const fare = results.Fare;
    const rules = results.MiniFareRules?.[0] || [];
    const [ssrData, setSsrData] = useState();

    const [activeSSRTab, setActiveSSRTab] = useState(null);
    const [selectedMeal, setSelectedMeal] = useState(null);
    const [selectedBaggage, setSelectedBaggage] = useState(null);
    const [passengers, setPassengers] = useState([]);
    const [qouteLoader, setQouteLoader] = useState(false)
    const [ssrLoader, setSsrLoader] = useState(false)
    const [resultindx1, setResultindx1] = useState(null)


    // Backend sends array inside array







    useEffect(() => {
        if (!ResultIdx || !TraceId) return;

        const fetchFareData = async () => {
            try {
                setQouteLoader(true)
                setSsrLoader(true)
                // 1️⃣ First call Fare Quote API
                const fareQuoteRes = await api.post("/flights/fare-quote", {
                    ResultIndex: ResultIdx,
                    TraceId: TraceId
                });
                setQouteLoader(false)

                const fareQuoteData = fareQuoteRes?.data?.data?.data;
                const treceno = fareQuoteRes?.data?.data?.trace_id
                setFareQuote(fareQuoteData);

                console.log("Fare Quote:", fareQuoteData);

                // ✅ Ensure required data exists before SSR call
                if (!fareQuoteData?.responseData?.Response?.Results?.ResultIndex) {
                    console.warn("ResultIndex missing for SSR call");
                    return;
                }

                const resultin = fareQuoteData?.responseData?.Response?.Results?.ResultIndex
                console.log("the result index is ", resultin)
                setResultindx1(resultin);

                // 2️⃣ Call Fare SSR API using Fare Quote data
                const ssrRes = await api.post("/flights/fare-ssr", {
                    ResultIndex: resultin,
                    TraceId: treceno
                });
                console.log("the ssr response is ", ssrRes);
                setSsrData(ssrRes?.data?.data);

                console.log("SSR Data are.....................:", ssrRes?.data?.data);
                setSsrLoader(false)

            } catch (error) {
                console.error("Fare Quote / SSR fetch failed", error);
            }
        };

        fetchFareData();
    }, [ResultIdx, TraceId]);



    // ✅ Normalize SSR data FIRST
    const mealSSR =
        ssrData?.responseData?.Response?.MealDynamic?.[0] || [];

    const baggageSSR =
        ssrData?.responseData?.Response?.Baggage?.[0] || [];

    // ✅ THEN use them in effects
    useEffect(() => {
        if (baggageSSR.length > 0) {
            setActiveSSRTab("BAGGAGE");
        } else if (mealSSR.length > 0) {
            setActiveSSRTab("MEAL");
        }
    }, [baggageSSR.length, mealSSR.length]);


    console.log("the meals are : ", mealSSR)
    console.log("the baggage are ", baggageSSR)

    const fareResult = fareQuote?.responseData?.Response?.Results

    console.log("the fareresult is ", fareResult);

    const passengerCount = fareResult?.FareBreakdown[0]?.PassengerCount
    console.log("the passenger count is ", passengerCount)

    const rows = ssrData?.responseData?.Response?.SeatDynamic?.[0]?.SegmentSeat?.[0]?.RowSeats || [];
    const [selectedSeats, setSelectedSeats] = useState([]);


    const handleSeatClick = (seat) => {
        if (seat.AvailablityType !== 1) return;

        const exists = selectedSeats.find(s => s.Code === seat.Code);

        // 🔁 Deselect seat
        if (exists) {
            setSelectedSeats(prev =>
                prev.filter(s => s.Code !== seat.Code)
            );
            return;
        }

        // ⛔ Seat limit
        if (selectedSeats.length >= totalPassengers) {
            alert(`You can select only ${totalPassengers} seats`);
            return;
        }

        // ✅ Select seat
        setSelectedSeats(prev => [...prev, seat]);
    };


    // Payload portion








    const totalPassengers =
        typeof passengerCount === "number"
            ? passengerCount
            : (passengerCount?.Adult || 0) +
            (passengerCount?.Child || 0) +
            (passengerCount?.Infant || 0);

    const [contactInfo, setContactInfo] = useState({
        Country: "India",
        CountryCode: "+91",
        ContactNo: "",
        Email: "",
        Address: "",
        City: "",
        PostalCode: ""
    });

    useEffect(() => {
        if (!fareQuote || !totalPassengers) return;

        const list = Array.from({ length: totalPassengers }, (_, index) => ({
            Title: "Mr",
            FirstName: "",
            LastName: "",
            DateOfBirth: "",
            Gender: 1,
            ContactNo: "",
            Email: "",
            PaxType: "1",
            IsLeadPax: index === 0
        }));

        setPassengers(list);
    }, [fareQuote, totalPassengers]);





    const handlePassengerChange = (index, field, value) => {
        setPassengers(prev => {
            const updated = [...prev];
            updated[index] = { ...updated[index], [field]: value };
            return updated;
        });
    };




    const passengerFare = fareResult?.Fare && {
        Currency: "INR",
        BaseFare: fareResult.Fare.BaseFare,
        Tax: fareResult.Fare.Tax,
        YQTax: 0,
        AdditionalTxnFeePub: 0,
        AdditionalTxnFeeOfrd: 0,
        OtherCharges: 0,
        Discount: fareResult.Fare.Discount,
        PublishedFare: fareResult.Fare.PublishedFare,
        OfferedFare: fareResult.Fare.OfferedFare,
        TdsOnCommission: fareResult.Fare.TdsOnCommission || 0,
        TdsOnPLB: 0,
        TdsOnIncentive: 0,
        ServiceFee: 0
    };


    const baggagePayload = selectedBaggage
        ? [{
            AirlineCode: selectedBaggage.AirlineCode,
            FlightNumber: selectedBaggage.FlightNumber,
            WayType: 1,
            Code: selectedBaggage.Code,
            Description: selectedBaggage.Description,
            Weight: selectedBaggage.Weight,
            Currency: selectedBaggage.Currency,
            Price: selectedBaggage.Price,
            Origin: selectedBaggage.Origin,
            Destination: selectedBaggage.Destination
        }]
        : [];

    const mealPayload = selectedMeal
        ? [{
            AirlineCode: selectedMeal.AirlineCode,
            FlightNumber: selectedMeal.FlightNumber,
            WayType: 1,
            Code: selectedMeal.Code,
            Description: selectedMeal.Description,
            AirlineDescription: selectedMeal.AirlineDescription,
            Quantity: 1,
            Currency: selectedMeal.Currency,
            Price: selectedMeal.Price,
            Origin: selectedMeal.Origin,
            Destination: selectedMeal.Destination
        }]
        : [];


    const seatPayload = selectedSeats.map(seat => ({
        AirlineCode: seat.AirlineCode,
        FlightNumber: seat.FlightNumber,
        SeatWayType: seat.SeatWayType || 0,
        Code: seat.Code,
        Description: seat.Description,
        SeatType: seat.SeatType,
        Currency: seat.Currency,
        Price: seat.Price,
        Origin: seat.Origin,
        Destination: seat.Destination,
        CraftType: seat.CraftType,
        AvailablityType: seat.AvailablityType || 0,
        RowNo: seat.RowNo,
        SeatNo: seat.SeatNo,
        Compartment: seat.Compartment || 0,
        Deck: seat.Deck || 0

    }));




    const passengersPayload = passengers.map(pax => ({
        Title: pax.Title,
        FirstName: pax.FirstName,
        LastName: pax.LastName,
        PaxType: pax.PaxType,
        DateOfBirth: pax.DateOfBirth
            ? `${pax.DateOfBirth}T00:00:00`
            : null,
        Gender: pax.Gender,

        PassportNo: "",
        PassportExpiry: "",

        AddressLine1: pax.IsLeadPax ? contactInfo.Address : "",
        AddressLine2: "",
        City: pax.IsLeadPax ? contactInfo.City : "",
        CountryCode: "IN",
        CountryName: "India",
        Nationality: "IN",

        ContactNo: pax.IsLeadPax ? contactInfo.ContactNo : "",
        Email: pax.IsLeadPax ? contactInfo.Email : "",

        IsLeadPax: pax.IsLeadPax,
        Fare: passengerFare,

        GSTCompanyAddress: null,
        GSTCompanyContactNumber: null,
        GSTCompanyName: null,
        GSTNumber: null,
        GSTCompanyEmail: null,

        Baggage: baggagePayload,
        MealDynamic: mealPayload,
        SeatDynamic: seatPayload
    }));
    const passengersPayload1 = passengers.map(pax => ({
        Title: pax.Title,
        FirstName: pax.FirstName,
        LastName: pax.LastName,
        PaxType: pax.PaxType,
        DateOfBirth: pax.DateOfBirth
            ? `${pax.DateOfBirth}T00:00:00`
            : null,
        Gender: pax.Gender,

        PassportNo: "",
        PassportExpiry: "",

        AddressLine1: pax.IsLeadPax ? contactInfo.Address : "",
        AddressLine2: "",
        City: pax.IsLeadPax ? contactInfo.City : "",
        CountryCode: "IN",
        CountryName: "India",
        Nationality: "IN",

        ContactNo: pax.IsLeadPax ? contactInfo.ContactNo : "",
        Email: pax.IsLeadPax ? contactInfo.Email : "",

        IsLeadPax: pax.IsLeadPax,

        GSTCompanyAddress: null,
        GSTCompanyContactNumber: null,
        GSTCompanyName: null,
        GSTNumber: null,
        GSTCompanyEmail: null,

        Baggage: baggagePayload,
        MealDynamic: mealPayload,
        SeatDynamic: seatPayload
    }));



    const bookingPayload = {
        ResultIndex: resultindx1,
        TraceId: ssrData?.responseData?.Response?.TraceId,
        IsLCC: "1",
        isoneway: "Yes",
        isDomestic: "Yes",
        IsDomesticReturn: "No",
        Passengers: passengersPayload
    };

    const bookingNonLCCPayload = {
        ResultIndex: resultindx1,
        TraceId: ssrData?.responseData?.Response?.TraceId,
        Passengers: passengersPayload1,
        IsLCC: "0",
        isoneway: "Yes",
        isDomestic: "Yes",
        IsDomesticReturn: "No",
        Fare: passengerFare

    }




    const handleBookFlight = async () => {

        // if (!contactInfo.ContactNo || !contactInfo.Email) {
        //     alert("Please enter contact number and email");
        //     return;
        // }
        for (let i = 0; i < passengers.length; i++) {
            const p = passengers[i];

            if (
                !p.Title ||
                !p.FirstName ||
                !p.LastName ||
                !p.DateOfBirth ||
                !p.ContactNo ||
                !p.Email
            ) {
                showToast(`Please fill all details for Passenger ${i + 1}`, "error");
                return;
            }

            // Email format validation
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(p.Email)) {
                showToast(`Invalid email for Passenger ${i + 1}`, "error");
                return;
            }

            // Phone validation (10 digit)
            const phoneRegex = /^[6-9]\d{9}$/;
            if (!phoneRegex.test(p.ContactNo)) {
                showToast(`Invalid mobile number for Passenger ${i + 1}`, "error");
                return;
            }
        }


        const accessToken = localStorage.getItem("accessToken");
        const payload = {
            TraceId: TraceId,
            seat_codes: selectedSeats.map(seat => seat.Code),
            baggage_code: selectedBaggage ? selectedBaggage.Code : null,
            meal_code: selectedMeal ? selectedMeal.Code : null,

        };
        console.log("the payload for order is ", payload)

        try {
            const order = await api.post(
                "/flight/create-order-flight", payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${accessToken}`,
                    },
                }
            );

            console.log("order:", order);
            if (order?.status !== 200) {
                alert("Error creating order");
                return;
            }
            const options = {
                key: order?.data?.payment?.razorpay_key, // public key only
                amount: order?.data?.price_breakup?.total,
                currency: order?.data?.order?.currency,
                name: "Jayraj Flight Booking",
                description: "Test Transaction",
                order_id: order?.data?.payment?.razorpay_order_id,
                handler: async function (response) {
                    // send to backend for verification
                    console.log("response,", response);
                    const verifyPayload = {
                        trace_id: TraceId,
                        razorpay_order_id: response.razorpay_order_id,     // from Razorpay
                        razorpay_payment_id: response.razorpay_payment_id,
                        razorpay_signature: response.razorpay_signature
                    };
                    console.log("response,", verifyPayload);
                    try {
                        const verifyRes = await api.post("/flight/verify-payment-flight", verifyPayload,
                            {
                                headers: {
                                    "Content-Type": "application/json",
                                    "Authorization": `Bearer ${accessToken}`,
                                },
                            }
                        );
                        console.log("verifyRes:", verifyRes)
                        // if (customer?.franchise_id) {
                        //     await api.post("/franchise-ledger", {
                        //         booking_id: bookingDetails?.id,
                        //         module: "hotel",
                        //     }, {
                        //         headers: {
                        //             "Content-Type": "application/json",
                        //             "Authorization": `Bearer ${accessToken}`,
                        //         },
                        //     }
                        //     );
                        // }

                        // if (couponCode) {

                        //     await api.post("/coupons/apply", {
                        //         code: couponCode,
                        //         booking_type: "Hotel",
                        //         booking_id: bookingDetails?.id,
                        //         amount: bookingDetails.total_price,
                        //         discount: totaldiscount
                        //     }, {
                        //         headers: {
                        //             "Content-Type": "application/json",
                        //             "Authorization": `Bearer ${accessToken}`,
                        //         },
                        //     }
                        //     );
                        //     console.log("verifyRes:", verifyRes)

                        // }
                        if (verifyRes?.status === 200) {
                            // alert("Payment Successfully Done!");



                            try {
                                console.log("the booking payload is ", bookingPayload)
                                if (fareQuote?.responseData?.Response?.Results.IsLCC) {
                                    const res = await api.post("/flights/ticket-for-lcc", bookingPayload,
                                        {
                                            headers: {
                                                "Content-Type": "application/json",
                                                "Authorization": `Bearer ${accessToken}`,
                                            },
                                        }
                                    );
                                    console.log("Booking Success:", res.data);
                                } else {

                                    const response = api.post("/flights/book/non-lcc", bookingNonLCCPayload,
                                        {
                                            headers: {
                                                "Content-Type": "application/json",
                                                "Authorization": `Bearer ${accessToken}`,
                                            },
                                        }
                                    )
                                    console.log("the response from non lcc first api", response)
                                }

                            } catch (err) {
                                console.error("Booking Failed:", err);
                                alert("Booking failed. Please contact support.");
                                return;
                            }

                            showToast("Payment Successfully Done!. Don't close the browser.", "success");

                            // navigate("/profile/hotel-info");
                            // setLoading(false);
                        } else {
                            alert("Payment verification failed");
                        }
                    } catch (err) {
                        alert("Error verifying payment");
                        console.log(err)
                    }
                },
                prefill: {
                    name: "Akash Shaikh",
                    email: "akash@example.com",
                    contact: "9999999999",
                },
                theme: {
                    color: "#3399cc",
                },
            };

            const rzp = new window.Razorpay(options);
            rzp.open();
            console.log("after payment", rzp)

        } catch (err) {
            console.error("Error creating order:", err);
        }



        // alert("The Razorpay payment page will be available shortly. Please try again later.")
        // return;


    };


    const [totalPrice, setTotalPrice] = useState(0);

    useEffect(() => {
        const calculatePrice = () => {
            if (!fareResult?.Fare) return;

            const baseFare = fareResult.Fare.PublishedFare || 0;



            const baggagePrice =
                selectedBaggage?.Price
                    ? selectedBaggage.Price
                    : 0;

            const mealPrice =
                selectedMeal?.Price
                    ? selectedMeal.Price
                    : 0;

            const seatPrice = selectedSeats.reduce(
                (sum, seat) => sum + (seat.Price || 0),
                0
            );


            const finalTotal =
                baseFare +
                baggagePrice +
                mealPrice +
                seatPrice;


            setTotalPrice(finalTotal);
        };

        calculatePrice();
    }, [
        selectedMeal,
        selectedBaggage,
        selectedSeats,
        fareResult?.Fare?.PublishedFare,
    ]);

    const handleBaggageSelect = (bag) => {
        setSelectedBaggage(prev =>
            prev?.Code === bag.Code ? null : bag
        );
    };

    const handleSelectedMeal = (meal) => {
        setSelectedMeal(prev =>
            prev?.Code === meal.Code ? null : meal
        );
    };



    useEffect(() => {
        const leadPax = passengers.find(p => p.IsLeadPax);
        if (!leadPax) return;

        setContactInfo(prev => ({
            ...prev,
            ContactNo: leadPax.ContactNo,
            Email: leadPax.Email
        }));
    }, [passengers]);

    return (
        <>
            <Navber />
            <div style={{ maxWidth: "1100px", margin: "auto" }}>
                <div className="pg">
                    {/* Top banner */}
                    <div className="banner">
                        <div>
                            <div className="bannerTitle">
                                Nice choice! We can’t guarantee this price for long, lock in this flight before it’s gone!
                            </div>
                            <div className="bannerSub">
                                Still unsure? Drop your requirements and we will let you know when the price changes.
                            </div>
                        </div>
                        <div className="bannerImg"></div>
                    </div>

                    {/* Main section */}
                    <div className="wrap1">
                        <div className="grid1">
                            {/* ================= LEFT COLUMN ================= */}
                            <div>
                                {/* Flight section */}
                                <div className="fs-wrap">
                                    <div className="fs-top">
                                        <div className="fs-topLeft">{firstSegment.Origin.Airport.CityName} ({firstSegment.Origin.Airport.CityCode}) → {segments[1]?.Destination.Airport.CityName || segments[0]?.Destination.Airport.CityName} ({segments[1]?.Destination.Airport.CityCode || segments[0]?.Destination.Airport.CityCode})</div>
                                        <div className="fs-topRight">{formatDate(firstSegment.Origin.DepTime)} {formatTime(firstSegment.Origin.DepTime)} → {formatDate(segments[1]?.Destination.ArrTime || segments[0]?.Destination.ArrTime)} {formatTime(segments[1]?.Destination.ArrTime || segments[0]?.Destination.ArrTime)}</div>
                                    </div>

                                    {/* Flight 1 */}
                                    {
                                        segments.map((seg) => (
                                            <div className="fs-block">
                                                <div className="fs-strip">
                                                    <span className="fs-badge">Departure flight:</span>
                                                    <span className="fs-stripCity">{seg.Origin.Airport.CityName}</span>
                                                    <span className="fs-stripArrow">✈</span>
                                                    <span className="fs-stripCity">{seg.Destination.Airport.CityName}</span>
                                                    <span className="fs-stripDur"> {Math.floor(seg.Duration / 60)}h {seg.Duration % 60}m</span>
                                                </div>

                                                <div className="fs-body">
                                                    <div className="fs-leftRail">
                                                        <div className="fs-logoBox">
                                                            <span className="fs-logoDots">⋯⋯</span>
                                                            <span className="fs-logoMark">↗</span>
                                                        </div>
                                                        <div className="fs-railLine" />
                                                    </div>

                                                    <div className="fs-mid">
                                                        <div className="fs-timeRow">
                                                            <span className="fs-date">{formatDate(seg.Origin.DepTime)}</span>
                                                            <span className="fs-time">{formatTime(seg.Origin.DepTime)}</span>
                                                            <span className="fs-bigArrow">→</span>
                                                            <span className="fs-date">{formatDate(seg.Destination.ArrTime)}</span>
                                                            <span className="fs-time">{formatTime(seg.Destination.ArrTime)}</span>
                                                        </div>

                                                        <div className="fs-subRow">
                                                            <span className="fs-clock">🕒</span>
                                                            <span className="fs-subBold"> {Math.floor(seg.Duration / 60)}h {seg.Duration % 60}m</span>
                                                        </div>

                                                        <div className="fs-subRow">
                                                            <span className="fs-airline">{seg?.Airline?.AirlineName}</span>
                                                            <span className="fs-flightNo">{seg?.Airline?.AirlineCode}-{seg?.Airline?.FlightNumber}</span>
                                                        </div>

                                                        <div className="fs-routeRow">
                                                            <span className="fs-airport">
                                                                {seg.Origin.Airport.AirportCode} {seg.Origin.Airport.AirportName}
                                                            </span>

                                                            <span className="fs-midPlane">

                                                                <span className="fs-midPlaneIcon">✈</span>

                                                            </span>

                                                            <span className="fs-airport">{seg.Destination.Airport.AirportCode} {seg.Destination.Airport.AirportName}</span>
                                                        </div>
                                                    </div>

                                                    <div className="fs-right">
                                                        <div className="fs-ribbon">
                                                            <span className="fs-ribbonNotch" />
                                                            Economy
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    }

                                </div>

                                {/* Passenger card */}
                                <div className="jr-card">

                                    {/* Passenger Section */}
                                    {!fareQuote && (
                                        <div style={{ padding: 20 }}>Loading passenger details…</div>
                                    )}

                                    {fareQuote &&
                                        passengers.map((pax, index) => (
                                            <div className="jr-card" key={index}>
                                                <div className="jr-title">
                                                    Passenger {index + 1}
                                                    {pax.IsLeadPax && " (Lead Passenger)"}
                                                </div>

                                                <div className="jr-formGrid2">

                                                    {/* Title */}
                                                    <div className="jr-field">
                                                        <div className="jr-label">Title</div>
                                                        <select
                                                            className="jr-input"
                                                            value={pax.Title || ""}
                                                            required
                                                            onChange={e =>
                                                                handlePassengerChange(index, "Title", e.target.value)
                                                            }
                                                        >
                                                            <option value="">Select Title</option>
                                                            <option value="Mr">Mr</option>
                                                            <option value="Mrs">Mrs</option>
                                                            <option value="Ms">Ms</option>
                                                        </select>
                                                    </div>

                                                    {/* First Name */}
                                                    <div className="jr-field">
                                                        <div className="jr-label">First Name</div>
                                                        <input
                                                            className="jr-input"
                                                            placeholder="Enter First Name"
                                                            value={pax.FirstName || ""}
                                                            required
                                                            onChange={e =>
                                                                handlePassengerChange(index, "FirstName", e.target.value)
                                                            }
                                                        />
                                                    </div>

                                                    {/* Last Name */}
                                                    <div className="jr-field">
                                                        <div className="jr-label">Last Name</div>
                                                        <input
                                                            className="jr-input"
                                                            placeholder="Enter Last Name"
                                                            value={pax.LastName || ""}
                                                            required
                                                            onChange={e =>
                                                                handlePassengerChange(index, "LastName", e.target.value)
                                                            }
                                                        />
                                                    </div>

                                                    {/* DOB */}
                                                    <div className="jr-field">
                                                        <div className="jr-label">Date of Birth</div>
                                                        <input
                                                            type="date"
                                                            className="jr-input"
                                                            value={pax.DateOfBirth || ""}
                                                            required
                                                            onChange={e =>
                                                                handlePassengerChange(index, "DateOfBirth", e.target.value)
                                                            }
                                                        />
                                                    </div>

                                                    {/* Mobile Number (Now Required for ALL) */}
                                                    <div className="jr-field">
                                                        <div className="jr-label">Mobile Number</div>
                                                        <input
                                                            className="jr-input"
                                                            placeholder="Enter Mobile Number"
                                                            value={pax.ContactNo || ""}
                                                            required
                                                            onChange={e =>
                                                                handlePassengerChange(index, "ContactNo", e.target.value)
                                                            }
                                                        />
                                                    </div>

                                                    {/* Email (Now Required for ALL) */}
                                                    <div className="jr-field">
                                                        <div className="jr-label">Email</div>
                                                        <input
                                                            type="email"
                                                            className="jr-input"
                                                            placeholder="Enter Email"
                                                            value={pax.Email || ""}
                                                            required
                                                            onChange={e =>
                                                                handlePassengerChange(index, "Email", e.target.value)
                                                            }
                                                        />
                                                    </div>

                                                </div>
                                            </div>
                                        ))
                                    }





                                    <div className="jr-subTitle">Simple Service Request Details</div>
                                    {
                                        segments?.map((seg) => (
                                            <div className="jr-ssr2">
                                                <div className="jr-ssrBox2">
                                                    <div className="jr-ssrKey2">SECTOR</div>
                                                    <div className="jr-ssrVal2">{seg?.Origin?.Airport?.AirportCode} - {seg?.Destination?.Airport?.AirportCode}</div>
                                                </div>
                                                <div className="jr-ssrBox2">
                                                    <div className="jr-ssrKey2">CABIN</div>
                                                    <div className="jr-ssrVal2">{seg?.CabinBaggage}</div>
                                                </div>
                                                <div className="jr-ssrBox2">
                                                    <div className="jr-ssrKey2">CHECK-IN</div>
                                                    <div className="jr-ssrVal2">{seg?.Baggage}</div>
                                                </div>
                                                <div className="jr-ssrBox2">
                                                    <div className="jr-ssrKey2">OPERATED BY</div>
                                                    <div className="jr-ssrVal2">{seg?.Airline?.AirlineCode}</div>
                                                </div>
                                            </div>
                                        ))
                                    }


                                    <div className="jr-tabs2">
                                        {baggageSSR.length > 0 ?
                                            <button
                                                className={`jr-tab2 ${activeSSRTab === "BAGGAGE" ? "jr-tabActive2" : ""}`}
                                                onClick={() => setActiveSSRTab("BAGGAGE")}
                                            >
                                                🧳 Add Baggage
                                            </button>
                                            : "Extra Features are loading..."
                                        }

                                        {mealSSR.length > 0 && (
                                            <button
                                                className={`jr-tab2 ${activeSSRTab === "MEAL" ? "jr-tabActive2" : ""}`}
                                                onClick={() => setActiveSSRTab("MEAL")}
                                            >
                                                🍱 Add Meal Preferences
                                            </button>
                                        )}
                                    </div>


                                    {activeSSRTab === "MEAL" && (
                                        <div className="jr-bagList">
                                            {mealSSR.map((meal) => {
                                                const isSelected = selectedMeal?.Code === meal.Code;
                                                const isNoMeal = meal.Code === "NoMeal";

                                                return (


                                                    <div
                                                        key={meal.Code}
                                                        className={`jr-bagRow ${isSelected ? "jr-bagRowSelected" : ""}`}
                                                    >
                                                        <div className="jr-bagIconBox">
                                                            <span className="jr-bagIcon">🍱</span>
                                                        </div>

                                                        <div className="jr-bagInfo">
                                                            <div className="jr-bagInfoTop">
                                                                {isNoMeal ? "No Meal" : "Meal"}({meal?.Origin}- {meal?.Destination})
                                                            </div>
                                                            <div className="jr-bagInfoSub">
                                                                {meal.AirlineDescription || "No Meal Selected"}
                                                            </div>
                                                        </div>

                                                        <div className="jr-bagRight">
                                                            <div className="jr-bagPrice2">
                                                                {meal.Currency === "INR" ? "₹" : meal.Currency}{" "}
                                                                {meal.Price.toLocaleString()}
                                                            </div>

                                                            <button
                                                                className={`jr-selectBtn ${isSelected ? "jr-removeBtn" : ""}`}
                                                                onClick={() => handleSelectedMeal(meal)}
                                                            >
                                                                {isSelected ? "Remove" : "Select"}
                                                            </button>

                                                        </div>
                                                    </div>

                                                );
                                            })}
                                        </div>
                                    )}



                                    {activeSSRTab === "BAGGAGE" && (
                                        <div className="jr-bagList">
                                            {baggageSSR.map((bag, i) => {
                                                const isSelected = selectedBaggage?.Code === bag.Code;

                                                return (
                                                    <div
                                                        key={i}
                                                        className={`jr-bagRow ${isSelected ? "jr-bagRowSelected" : ""}`}
                                                    >
                                                        <div className="jr-bagIconBox">
                                                            <span className="jr-bagIcon">🧳</span>
                                                        </div>

                                                        <div className="jr-bagInfo">
                                                            <div className="jr-bagInfoTop">Additional</div>
                                                            <div className="jr-bagInfoSub">
                                                                {bag.Weight === 0 ? "No Baggage" : `${bag.Weight} KG`}
                                                            </div>
                                                        </div>

                                                        <div className="jr-bagRight">
                                                            <div className="jr-bagPrice2">
                                                                ₹ {bag.Price.toLocaleString()}
                                                            </div>
                                                            <button
                                                                className={`jr-selectBtn ${isSelected ? "jr-removeBtn" : ""}`}
                                                                onClick={() => handleBaggageSelect(bag)}
                                                            >
                                                                {isSelected ? "Remove" : "Select"}
                                                            </button>

                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    )}


                                </div>

                                {/* -------------this is seat selection portion--------------- */}

                                <div className="seat-wrapper">
                                    <h2 className="seat-title">Select Your Seat</h2>

                                    {ssrData ?
                                        <div className="aircraft">
                                            <div className="cockpit">✈ Cockpit</div>

                                            {rows.map((row, rowIndex) => (
                                                <div key={rowIndex} className="seat-row">
                                                    <span className="row-number">{row.Seats?.[0]?.RowNo}</span>

                                                    <div className="seat-group">
                                                        {row.Seats.map((seat, index) => {
                                                            const isSelected = selectedSeats.some(
                                                                s => s.Code === seat.Code
                                                            );


                                                            return (
                                                                <div
                                                                    key={index}
                                                                    className={`seat 
                      ${seat.AvailablityType !== 1 ? "seat-blocked" : ""}
                      ${isSelected ? "seat-selected" : ""}
                    `}
                                                                    onClick={() => handleSeatClick(seat)}
                                                                >
                                                                    <span className="seat-code">{seat.SeatNo}</span>

                                                                    {seat.Price > 0 && seat.AvailablityType === 1 && (
                                                                        <span className="seat-price">₹{seat.Price}</span>
                                                                    )}
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                        :
                                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>{ssrLoader ? <CircularProgress /> : "No Available Response From backend"}</div>
                                    }
                                    {/* Summary */}
                                    {selectedSeats.length > 0 && (
                                        <div className="seat-summary">
                                            <h3>
                                                Selected Seats ({selectedSeats.length}/{totalPassengers})
                                            </h3>

                                            {selectedSeats.map(seat => (
                                                <p key={seat.Code}>
                                                    Seat <strong>{seat.Code}</strong> | ₹{seat.Price}
                                                </p>
                                            ))}

                                            <h4>
                                                Total Seat Price: ₹
                                                {selectedSeats.reduce((sum, s) => sum + (s.Price || 0), 0)}
                                            </h4>
                                        </div>
                                    )}

                                </div>

                                {/* ================= CONTACT INFO ================= */}
                                <div className="jr-card">
                                    <div className="jr-title">Contact Info</div>
                                    <div className="jr-note">
                                        We require a valid email address to contact you with the details of your booking.
                                    </div>

                                    <div className="jr-formGrid3">

                                        {/* Country */}
                                        <div className="jr-field">
                                            <div className="jr-label">Country</div>
                                            <select
                                                className="jr-input"
                                                required
                                                value={contactInfo.Country}
                                                onChange={e =>
                                                    setContactInfo({ ...contactInfo, Country: e.target.value })
                                                }
                                            >
                                                <option value="">Select Country</option>
                                                <option value="India">India</option>
                                            </select>
                                        </div>

                                        {/* Contact Number */}
                                        <div className="jr-field">
                                            <div className="jr-label">Contact Number</div>
                                            <div className="jr-phoneWrap">
                                                <span className="jr-phoneCode">{contactInfo.CountryCode}</span>
                                                <input
                                                    type="tel"
                                                    className="jr-input"
                                                    required
                                                    pattern="[0-9]{10}"
                                                    placeholder="Enter Your Contact Number"
                                                    value={contactInfo.ContactNo}
                                                    onChange={e =>
                                                        setContactInfo({ ...contactInfo, ContactNo: e.target.value })
                                                    }
                                                />
                                            </div>
                                        </div>

                                        {/* Email */}
                                        <div className="jr-field">
                                            <div className="jr-label">Email</div>
                                            <input
                                                type="email"
                                                className="jr-input"
                                                required
                                                placeholder="Enter Your Email"
                                                value={contactInfo.Email}
                                                onChange={e =>
                                                    setContactInfo({ ...contactInfo, Email: e.target.value })
                                                }
                                            />
                                        </div>

                                        {/* Address */}
                                        <div className="jr-field">
                                            <div className="jr-label">Address</div>
                                            <input
                                                type="text"
                                                className="jr-input"
                                                required
                                                placeholder="Enter Your Address"
                                                value={contactInfo.Address}
                                                onChange={e =>
                                                    setContactInfo({ ...contactInfo, Address: e.target.value })
                                                }
                                            />
                                        </div>

                                        {/* City */}
                                        <div className="jr-field">
                                            <div className="jr-label">City</div>
                                            <input
                                                type="text"
                                                className="jr-input"
                                                required
                                                placeholder="Enter Your City"
                                                value={contactInfo.City}
                                                onChange={e =>
                                                    setContactInfo({ ...contactInfo, City: e.target.value })
                                                }
                                            />
                                        </div>

                                        {/* Postal Code */}
                                        <div className="jr-field">
                                            <div className="jr-label">Postal / Zip Code</div>
                                            <input
                                                type="text"
                                                className="jr-input"
                                                required
                                                pattern="[0-9]{6}"
                                                placeholder="Enter Your Postal Code"
                                                value={contactInfo.PostalCode}
                                                onChange={e =>
                                                    setContactInfo({ ...contactInfo, PostalCode: e.target.value })
                                                }
                                            />
                                        </div>

                                    </div>
                                </div>



                                <button onClick={handleBookFlight} style={{ display: "flex", width: "100%", backgroundColor: "gold", color: "green", justifyContent: "center", padding: "10px 20px", borderRadius: "10px", border: "none", margin: "10px" }}>Proceed to Pay</button>

                            </div>

                            {/* ================= RIGHT COLUMN ================= */}
                            <div className="rightCol">
                                {
                                    fareResult ?
                                        <div className="card">
                                            <div className="title">Fare Summary</div>

                                            <div className="rowfare"><span>Adults x 1</span><span></span></div>
                                            <div className="rowfare"><span>Base fare:</span><span>{fareResult?.Fare?.BaseFare}</span></div>
                                            <div className="rowfare"><span>Tax:</span><span>{fareResult?.Fare?.Tax}</span></div>
                                            <div className="rowfare"><span>Discount:</span><span>-{fareResult?.Fare?.Discount}</span></div>
                                            {selectedBaggage && (
                                                <div className="rowfare">
                                                    <span>Baggage</span>
                                                    <span>₹ {selectedBaggage.Price}</span>
                                                </div>
                                            )}

                                            {selectedMeal && (
                                                <div className="rowfare">
                                                    <span>Meal</span>
                                                    <span>₹ {selectedMeal.Price}</span>
                                                </div>
                                            )}
                                            {selectedSeats && (
                                                <div className="rowfare">
                                                    <span>Seat Price</span>
                                                    <span>₹ {selectedSeats.reduce((sum, s) => sum + (s.Price || 0), 0)}</span>
                                                </div>
                                            )}

                                            <div className="rowfare bold"><span>Total:</span><span className="amt">₹ {totalPrice.toLocaleString()}</span>
                                            </div>

                                            <div className="total">
                                                <span>Total Amount</span>
                                                <span className="amt">₹ {totalPrice.toLocaleString()}</span>
                                            </div>
                                        </div> : <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>{qouteLoader ? <CircularProgress /> : "No Available Response From backend for Price Summary"}</div>
                                }

                                <div className="card note">
                                    Full payment will be charged to your credit card / net banking when you book this flight.
                                    Your bank may convert the payment and charge extra conversion fees.
                                </div>

                                <div className="card">
                                    <div className="ref">● {fareResult?.IsRefundable ? "Refundable" : "Non Refundable"}</div>
                                    <div className="title">Payment Method</div>
                                    <div className="note2">
                                        An online prepayment of ₹ {totalPrice.toLocaleString()} is required to book this flight, you do not need to pay the flight rate at check-in.
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>


    );
}